export function PointHistoryModel() {
    this.caller = null;
    this.campaignId = null;
    this.campaignName = null;
    this.createDate = null;
    this.detail = null;
    this.info = null;
    this.input = null;
    this.message = null;
    this.pair = null;
    this.points = null;
    this.rowKey = null;
    this.type = null;
    this.userId = null;

    this.setDataFromApi = function (data) {
        this.caller = data.Caller;
        this.campaignId = data.CampaignId;
        this.campaignName = data.CampaignName;
        this.createDate = data.CreateDate;
        this.detail = data.Detail;
        this.info = data.Info;
        this.input = data.Input;
        this.message = data.Message;
        this.pair = data.Pair;
        this.points = data.Points;
        this.rowKey = data.RowKey;
        this.Timestamp = data.Timestamp;
        this.type = data.Type;
        this.userId = data.UserId;
    };
}
